import { Button, Grid } from "@material-ui/core";
import React from "react";

function SubmitRule({ disabled, handleClick, rule }) {
  return (
    <Grid
      container
      alignItems="center"
      spacing={1}
      style={{
        marginTop: 20,
      }}
    >
      <Grid item style={{ width: "20%" }}></Grid>
      <Grid item style={{ width: "50%" }}>
        <Button
          color="primary"
          variant="contained"
          fullWidth
          onClick={handleClick}
          disabled={disabled}
        >
          {!!rule?.id ? "EDITAR REGRA" : "CRIAR NOVA REGRA"}
        </Button>
      </Grid>
    </Grid>
  );
}

export default SubmitRule;
